import { Component, inject, Input } from '@angular/core';
import { UserTrackerConsent } from '../../models/userTrackConsent.model';
import { DatePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ConsentDetailsModalComponent } from '../consent-details-modal/consent-details-modal.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-consent-timeline',
  imports: [NgFor,NgIf,NgClass, DatePipe, MatDialogModule,MatIconModule ],
  templateUrl: './consent-timeline.component.html',
  styleUrl: './consent-timeline.component.scss'
})
export class ConsentTimelineComponent {

  private dialog = inject(MatDialog)

  @Input() userTrackerConsents!: UserTrackerConsent[]
  @Input() viewMode: 'table' | 'timeline' = 'timeline'
  @Input() enableViewOptions: boolean = false

  get userTrackerConsentsSorted() {
 
    return this.userTrackerConsents
      .slice()
      .sort((a, b) => new Date(b.DateTime).getTime() - new Date(a.DateTime).getTime());
  }

   setViewMode(mode: 'table' | 'timeline') {
    this.viewMode = mode;
  }

  getChannelIcon(channel: string): string {
    switch (channel) {
      case 'SMS': return 'sms';
      case 'Call': return 'call';
      case 'Mail': return 'alternate_email';
      default: return 'help';
    }
  }

  openDetails(item: UserTrackerConsent) {
  this.dialog.open(ConsentDetailsModalComponent, {
    width: '500px',
    data: item
  });
}
}
